<div class="posts">
  <div class="posts__list" aria-live="polite" [attr.aria-busy]="store.isLoading">
    @if (segment === 'topics') {
      @if (topicCards.length) {
        <ul class="posts__topics">
          @for (card of topicCards; track $index) {
            <li><ut-community-profile-activity-card [card]="card" [user]="me || {}"></ut-community-profile-activity-card></li>
          }
        </ul>
      }
    } @else {
      @for (item of store.feedItems; track item.id) {
        <div class="posts__item">
          <ut-community-feed-item [item]="item" [user]="me || {}" (deleted)="remove(item)">
            @if (isOwn) {
              <ut-community-profile-pin-action feedItemAction [item]="item" (changed)="reload()"></ut-community-profile-pin-action>
            } @else {
              <ut-community-profile-pinned-label feedItemLabel [item]="item"></ut-community-profile-pinned-label>
            }
          </ut-community-feed-item>
        </div>
      }
    }

    @if (!store.isLoading && !store.feedItems.length) {
      <div class="card empty">
        <span class="empty__icon" aria-hidden="true"><span class="material-icons">article</span></span>
        @switch (segment) {
          @case ('articles') {
            @if (isOwn) {
              <p class="empty__title">No articles yet</p>
              <p class="empty__text">Share what you've learned. Articles are reviewed and published to the community.</p>
              @if (me?.current_user_permissions?.create_article) {
                <a class="ut-btn" uiSref="newarticle">Write an article</a>
              }
            } @else {
              <p class="empty__title">{{ firstName }} hasn't published any articles</p>
              <p class="empty__text">Check back later, or follow {{ firstName }} to see new articles in your feed.</p>
            }
          }
          @case ('status') {
            <p class="empty__title">{{ isOwn ? 'No status updates yet' : firstName + " hasn't posted any status updates" }}</p>
            @if (isOwn) {
              <p class="empty__text">Post one from the community page to share what you're testing.</p>
              <a class="ut-btn" uiSref="community">Community page</a>
            }
          }
          @default {
            <p class="empty__title">{{ isOwn ? 'No forum posts yet' : firstName + " hasn't posted in the forums" }}</p>
            @if (isOwn) {
              <p class="empty__text">Ask a question or start a discussion in the forums.</p>
              <a class="ut-btn" href="/forums">Browse the forums</a>
            }
          }
        }
      </div>
    }

    @if (store.isLoading) {
      <ut-skeleton-list></ut-skeleton-list>
    } @else if (!store.isLastPage) {
      <button type="button" class="ut-btn ut-btn--secondary more" (click)="loadMore()">View more</button>
    }
  </div>
</div>
